import { render, staticRenderFns } from "./NewsService.vue?vue&type=template&id=779d1820&"
import script from "./NewsService.vue?vue&type=script&lang=js&"
export * from "./NewsService.vue?vue&type=script&lang=js&"
import style0 from "./NewsService.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports